<template>
  <div id="page"></div>
  <NewLoading fullscreen v-if="loadsdk" />
  <!-- <PluginPanel v-if="!loadsdk" /> -->
</template>
<script lang="ts" setup>
import { onMounted, nextTick, ref } from "vue";
import { useSdkStore } from "@/stores/sdk";
import { initSdk } from "@/sdk/init";
// @ts-ignore
import PluginPanel from '@/components/plugin/plugin.vue'
// @ts-ignore
import NewLoading from '@/components/loading/loadingComp.vue'
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute()
const sdkStore = useSdkStore();
import { initDesign } from '@/common/initDesign'
import { initGlobalConfig } from '@/common/initGlobalConfig'
import { initClient } from '@/common/inituser'
import { useUserStore } from '@/stores/user'
import { createDesign } from '@/api/affairs'
const userStore = useUserStore()
const islogin = userStore.isLoggedIn
const loadsdk = ref(false)
//@ts-ignore
onMounted(async () => {
  if (islogin) {
    if (!route.query.id) {
      let pk = localStorage.getItem('pk')
      if (pk) {
        router.replace({
          path: '/editor',
          query: {
            id: pk,
            mode: "user"
          }
        })
      } else {
        const res = await createDesign({
          height: 1000,
          template_id: 0,
          name: '未命名模板',
          width: 1000,
        })
        const params = {
          id: String(res.data?.data?.pk ?? ''),
          mode: 'user',
        }
        localStorage.setItem('pk', String(res.data?.data?.pk ?? ''))
        router.replace({
          path: '/editor',
          query: params
        })
      }
    } else {
      localStorage.setItem('pk', route.query.id as string)
    }
    // localStorage.setItem('token', route.query?.token as string)
  } else {


  }


  loadsdk.value = true
  let title = localStorage.getItem('admin-api-user_name')
  if (title) {
    document.title = title
  } else {
    document.title = '设计引擎'
  }
  await nextTick();
  await initGlobalConfig()
  await initClient()

  // setTimeout(async () => {
  const desginsdk = await initSdk("#page", islogin);
  sdkStore.setSdk(desginsdk);

  loadsdk.value = false
  // }, 500);


  initDesign()
});
</script>
<style lang="scss">
.custom-thin {
  position: fixed;
  top: 10px;
  left: 10px;
}
</style>
